
//Importaciones
import  React, { useRef } from 'react';
import PropTypes from 'prop-types';

function Cause(props) {
    //Helpers

    //Parametros de entrada.
    const {
        inputParam_RootCause = null,
        inputParam_IsPreSelected = null,
        inputParam_Index = null,
        inputParam_OnSelectCause = null,
        inputParam_SelectedCauses = null,
        inputParam_SelectedCausesExcedded = null,
    } = props;

    //Parametros de componente.
    const inputRef = useRef()

    //Funciones de componente.
    const onCauseClick = (selectedCauses, onSelectedCausesExcedded) => {
        let selected = !(inputRef.current.className.indexOf("selectedFishboneCause") !== -1);

        if (selectedCauses.length < 3) {
            if (inputRef.current.className.indexOf("selectedFishboneCause") !== -1) {
                inputRef.current.className = ""
            }
            else {
                inputRef.current.className = "selectedFishboneCause"
            }  
        }
        else {
            inputRef.current.className = ""
        }
        
        inputParam_OnSelectCause && inputParam_OnSelectCause(selected, inputParam_RootCause.id, selectedCauses, onSelectedCausesExcedded);
    }

    //Render de componente.
    return <div
        role="button"
        ref={inputRef}
        onClick={() => onCauseClick(inputParam_SelectedCauses, inputParam_SelectedCausesExcedded)}
        className={inputParam_IsPreSelected ? "selectedFishboneCause": ""}
        id={inputParam_RootCause.id}
        key={`root_causes_${inputParam_RootCause.text}_${inputParam_Index}`}>
            {inputParam_RootCause.text}
            <i style={{ fontSize: 16, verticalAlign: "middle"}} className={ `ms-Icon ms-Icon--ChevronRightMed` } ></i>
    </div>
}

///Proptypes
Cause.propTypes = {
    inputParam_Index: PropTypes.number.isRequired,
    inputParam_RootCause: PropTypes.object.isRequired,
    inputParam_IsPreSelected: PropTypes.bool.isRequired,
    inputParam_OnSelectCause: PropTypes.func.isRequired,
    inputParam_SelectedCauses: PropTypes.array.isRequired,
    inputParam_SelectedCausesExcedded: PropTypes.func.isRequired,
};

export default Cause;